// extracted by extract-css-chunks-webpack-plugin
module.exports = {"floatAd":"floatAd-1bqkTfvy"};